import theme from "@/theme";

export const styles = {
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "32.5rem",
    bgcolor: theme.palette.custom.mainWhite,
    boxShadow: "0 32px 48px -8px rgba(0, 0, 0, 0.1), 0 0 14px -4px rgba(0, 0, 0, 0.05)",
    padding: 0,
    borderRadius: "1.5rem",
  },
  navigation: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "3.5rem",
    padding: "0 1.25rem",
  },
  navigationIcon: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
  },
  title: {
    padding: 0,
    textAlign: "center",
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.375rem",
    color: theme.palette.custom.blueGray900,
  },
  content: {
    padding: "1rem 2.5rem 2.5rem",
  },
  reasonValueInput: {
    maxWidth: "26.5rem",
    marginLeft: "0",
    paddingLeft: "0.5rem",
    justifyContent: "space-between",
    borderRadius: "0.5rem",
    "& .MuiFormControlLabel-label": {
      fontSize: "1rem !important",
      fontWeight: 500,
    },
    "&:hover": {
      bgcolor: theme.palette.custom.blueGray100,
    },
  },
  nextStepButton: {
    marginTop: "3.25rem",
    width: "100%",
    height: "54px",
    borderRadius: "1.75rem",
    padding: "18px 0px",
    fontSize: "1rem",
    textTransform: "none",
    bgcolor: theme.palette.custom.mainBlue,
    color: theme.palette.custom.mainWhite,
    "&:disabled": {
      bgcolor: theme.palette.custom.mainBlueDisable,
      color: theme.palette.custom.mainWhite,
    },
  },
  reasonInput: {
    width: "100%",
    padding: 0,
    fontSize: "1rem",
    textTransform: "none",
    bgcolor: theme.palette.custom.mainWhite,
    color: theme.palette.custom.mainBlack,
    "& .MuiOutlinedInput-root": {
      borderRadius: "1.5rem",
      margin: 0,
      fontSize: "16px",

      "& fieldset": {
        borderColor: "#E4E7E9",
      },
      "&:hover fieldset": {
        borderColor: "#E4E7E9",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E4E7E9",
      },

      padding: 0,
    },

    "& .MuiInputBase-input": {
      height: "101px !important",
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "150%",
      letterSpacing: 0,
      color: theme.palette.custom.mainBlack,

      padding: "12px 16px",
    },

    "& .MuiInputBase-input::placeholder": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "150%",
      letterSpacing: 0,
      color: "#C6CACE",
      opacity: 1,
    },
  },
};
